












































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { UserMeta, Team, UserPlan, AvailablePlan } from "../types";
import axios from "axios";
import consts from "../consts";
import { getters } from "../store/getters";
import { loadStripe } from "@stripe/stripe-js";

import { getDomain } from "@/auth";
import { source, refreshAxiosCancelToken } from "@/store/actions";
import amplitude from "amplitude-js";

@Component
export default class SubscribePlanSelection extends Vue {
  private selectedOption: string = "yearly";
  @Getter private userPlan!: UserPlan;
  @Getter private availablePlansLoading!: boolean;
  @Getter private proPlan!: AvailablePlan;
  @Getter private JWT!: string;
  @Action private fetchAvailablePlans!: () => any;
  @Action private fetchUserPlan!: () => any;
  @Prop() private redirectToSubscription?: boolean;
  @Prop() private isSkip?: boolean;

  @Action private resetState: any;
  private $amplitude: any;

  private created() {
    // Setup amplitude
    // source.cancel();
    // let domain = getDomain(window.location.href) as string | undefined;
    // this.$cookies.remove("ORAI_AUTH", "/", domain);
    // this.$cookies.remove(consts.currentLearnerTeam, "/", domain);
    // localStorage.clear();
    // this.resetState();
    // refreshAxiosCancelToken();
    // amplitude.getInstance().init(consts.amplitudeKey, "", {
    //   saveEvents: true,
    //   includeUtm: true,
    //   includeReferrer: true,
    // });
    // this.$amplitude = amplitude.getInstance();

    this.fetchAvailablePlans();
  }

  private async upgradeTo(typ: string) {
    const stripe = await loadStripe(consts.stripeKey);
    const response = await axios({
      url:
        consts.serverURL +
        "subscription/stripe/" +
        typ +
        (this.redirectToSubscription ? "?redirect=subscribe" : ""),
      headers: { Authentication: this.JWT },
    });
    stripe!.redirectToCheckout({
      sessionId: response.data["SessionID"],
    });
  }

  private onSkip() {
    this.$router.push({ name: "home" });
  }
}
